import {directive as onClickaway} from 'vue-clickaway';
import {mapActions, mapGetters, mapMutations} from 'vuex';

import videoProvider from '@/components/video-providers/index.vue'
import notice from '@/components/features/notice/index.vue';
import speakersMobile from '@/components/atoms/speakers-education-mobile/index.vue';
import {seo} from '@/mixins/seo'

export default {
    name: 'course-events-detail',
    mixins: [seo],
    directives: {
        onClickaway: onClickaway,
    },
    props: {},
    data() {
        return {
            active: false,
            value: '',
        }
    },
    components: {
        videoProvider,
        notice,
        speakersMobile
    },
    computed: {
        ...mapGetters({
            currentItem: 'coursesEvents/currentItem',
            isLoading: 'coursesEvents/isCurrentItemLoading',
        }),
    },
    created() {
        this.fetchContent({...this.$route.params}).then(() => {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
        })
    },
    methods: {
        ...mapActions({
            fetchContent: 'coursesEvents/FETCH_EVENTS_ITEM'
        }),
        ...mapMutations({
            setCurrentItem: 'coursesEvents/EVENTS_SET_ITEM'
        }),
        close() {
            this.active = false;
        },
        setValue(value) {
            this.value = value;
            this.active = false;
        }
    },
    destroyed() {
        this.setCurrentItem(null)
    }
}
